import {
  HttpEvent,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth-service/auth.service';
import { map } from 'rxjs/operators';
import { IDataObject } from '../models/interface/table-pagination/table-pagination';

export const authHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  let userToken = inject(AuthService).getUserToken();
  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${userToken}`,
      'Content-Type': 'application/json',
    },
  });
  return next(authReq).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        let modifiedBody: IDataObject[] = [];
        let responseData = event.body?.data;
        if (event.body && responseData && Array.isArray(responseData)) {
          if (responseData.length > 0) {
            modifiedBody = responseData.map((resObj: IDataObject) => {
              if (
                resObj &&
                typeof resObj === 'object' &&
                'is_active' in resObj
              ) {
                return { ...resObj, enableToggle: true };
              } else {
                return resObj;
              }
            });
          }

          return event.clone({ body: { ...event.body, data: modifiedBody } });
        }
      }

      return event;
    })
  );
};
